var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-alert',{attrs:{"color":"warning"}},[_c('div',{staticStyle:{"color":"white","font-weight":"bold"}},[_vm._v(" နေ့စဉ် Refresh ပြုလုပ်နိုင်သည့်အရေအတွက် ကုန်သွားပါပြီ ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }